module.exports = __webpack_public_path__ + "img/activate-admin-bg.67cbc967.png";